import React, { useState } from "react";

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value); // 调用父组件传递的搜索逻辑
  };

  return (
    <div style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
      <input
        type="text"
        placeholder="Search articles or tags..."
        value={query}
        onChange={handleInputChange}
        style={{
          padding: "8px",
          borderRadius: "5px",
          border: "1px solid #ddd",
          width: "100%",
        }}
      />
    </div>
  );
};

export default SearchBar;